import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/gallois.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		<var>S&#228;mtliche schriften und briefe series II, volume 1</var><br />
		Deutsche Akademie der Wissenschaften (ed)<br />
		pp 669-670<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 19 December 1678<br /><br />
		Translated from the French<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (17k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Leibniz to Jean Gallois (19 December 1678)</title>
            <meta name="description" content="An English translation of a LETTER TO JEAN GALLOIS by Gottfried Wilhelm Leibniz, from 19 December 1678" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ TO JEAN GALLOIS</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>A II 1, p669</b>]<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Letter to Abb&#233; Gallois, December 1678.<br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;...I will add something about Combinations, and of the Art of discovery in general, since I know that you appreciate these universal considerations, and that you yourself have important observations about them. I am more and more convinced of the usefulness and of the reality of this general science, and I see that few people have understood its full scope. But to make it easier and, so to speak, more tangible, I intend to make use of the Characteristic, of which I have spoken with you on occasion, and of which Algebra and Mathematics are merely examples. This Characteristic consists of a certain writing or language (since he who has the one can have the other) which perfectly corresponds to the relations of our thoughts. This characteristic would be completely different from any that has been envisaged until now, since the most important thing has been overlooked, which is that the characters of this writing have to serve for discovery and for judgement, like in algebra and in arithmetic. This writing will have great advantages; among others, one which seems important to me is that the chimeras, which are not understood by the person who advances them, will not be able to be written in these characters. An ignorant person will not be able to make use of them, or, when trying hard to do so, he will thereby become learned. For this script is even more instructive than that [<b>A II 1, p670</b>] of the Chinese, in which one has to be learned in order to be able to write. The knowledge of the language will advance with that of things, and will be very useful for that purpose, and a thing will be able to have as many names as properties; but there is only one which will be the key to all the others, even though one would not always be able to reach it in matters which depend on experiences. Nevertheless one will at least approach it by this path, as much as is possible <var>from the existing experimental data, or that which is within our power</var>. Often one will even decide which experiences are still necessary in order to fill the void. However, in order to achieve this great goal we need only the definitions of the terms of some received language, which is not infinite. And that reminds me of the definitions of words which have been made in the French Academy, which you spoke to me about one day, and which I would very much wish to see.<a name="1" href="#note1"><sup>1</sup></a> There will certainly be abbreviations in the execution, but I would not be able to explain myself on that matter in a few words.

                <br /><br /><br />
                <hr className='rightcol-hr' />
                <br /><br />
                NOTES:<br /><br />
                <a name="note1" href="#1">1.</a> Gallois was a member of the French Academy, which later published the <var>Dictionnaire de l'Academie Fran&#231;oise</var> [Dictionary of the French Academy] (2 vols, 1694) containing <var>Definitions des mots</var> [Definitions of words].<br /><br /><br />
                &#169; Lloyd Strickland 2007-08
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
